import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { POST_URL } from '@utils/api/endpoints.ts';

export type DuplicateFolderParams = {
  folder_id: number;
  name: string;
  parent_id: number | null;
};

export type DuplicateFolderResponse = {
  result: {
    id: number;
    name: string;
    items_copied: number;
  };
  count: number;
  total_results: number;
};

export const useDuplicateFolder = () => {
  const queryClient = useQueryClient();

  return useMutation<
    DuplicateFolderResponse,
    AxiosError<BaseError>,
    DuplicateFolderParams
  >(
    async ({ folder_id, name, parent_id }) => {
      const response = await Axios.post<DuplicateFolderResponse>(
        POST_URL(String(folder_id)).duplicateFolder,
        { name, parent_id }
      );
      return response.data;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('folders');
      },
      useErrorBoundary: false
    }
  );
};
